// frontend/src/services/api.js
import axios from 'axios';

// Automatically use relative path in production, and localhost in development
console.log("REACT_APP_API_URL IS: ", process.env.REACT_APP_API_URL); const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5050';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true  // Add this for CORS
});

let tokenResolver = null;

export const setTokenResolver = (resolver) => {
    tokenResolver = resolver;
};

// Update request interceptor to handle FormData and dynamic Clerk Tokens
api.interceptors.request.use(
    async (config) => {
        // Dynamically fetch the token securely via the injected resolver
        if (tokenResolver) {
            try {
                const token = await tokenResolver();
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
            } catch (err) {
                console.error("Failed to fetch Clerk token before request", err);
            }
        } else if (window.Clerk && window.Clerk.session) {
            // Fallback for race conditions where component mounts before AuthProvider sets tokenResolver
            try {
                const token = await window.Clerk.session.getToken();
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
            } catch (err) {
                console.error("Failed to fetch Clerk token from window object", err);
            }
        }
        
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Made-up responses for routes the backend does not have yet (services/mock), for `npm start`
// with REACT_APP_MOCK_API=true. Never in a production build: webpack drops this branch there.
if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_MOCK_API === 'true') {
    require('./mock').install(api);
}

// A 401 on any call means the session is gone; AuthContext listens and the shell shows
// "Your session has ended" (wf-shell-state-7) instead of redirecting.
export const SESSION_EXPIRED_EVENT = 'adas:session-expired';

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
        }
        return Promise.reject(error);
    }
);

// Note: Token injection is now handled dynamically by AuthContext via api.defaults.headers.

export default api;
